const settingConfig = require('../settings.js');
import { defineChain,mainnet } from '@reown/appkit/networks';

export const supportNetworks = [7234,233];
export const chainNameLists = [
  {chainId:7234,chainName:'Genesis Testnet'},
  {chainId:233,chainName:'Pioneer Testnet'},
];

export const blockScans = {
  233:settingConfig.pioneerScan,
  7234: settingConfig.genesisScan,
};

// Define the custom network
export const initVersePioneer = defineChain({
  id: 233,
  caipNetworkId: 'eip155:233',
  chainNamespace: 'eip155',
  name: 'Pioneer Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Pioneer InitVerse',
    symbol: 'INI',
  },
  rpcUrls: {
    default: {
      http: ['http://rpc-testnet.iniscan.com'],
    },
  },
  blockExplorers: {
    default: { 
      name: 'InitVersePioneerScan', 
      url: 'https://testnet.iniscan.com',
      apiUrl: 'https://explorer-testnet-api.iniscan.com/api',
    },
  },
});

export const initVerseGenesis = defineChain({
  id: 7234,
  caipNetworkId: 'eip155:7234',
  chainNamespace: 'eip155',
  name: 'Genesis Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Genesis InitVerse',
    symbol: 'INI',
  },
  rpcUrls: {
    default: {
      http: ['http://rpc-testnet.inichain.com'],
    },
  },
  blockExplorers: {
    default: { 
      name: 'InitVerseGenesisScan', 
      url: 'https://genesis-testnet.iniscan.com',
      apiUrl: 'https://explorer-testnet-api.inichain.com/api',
    },
  },
});


